const BASE_URL = 'https://saviagent.savictech.com/npd';

async function parseError(res) {
  let detail = `HTTP ${res.status}`;
  try {
    const data = await res.json();
    if (Array.isArray(data.detail)) {
      detail = data.detail
        .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' -> ') : e.loc}] ${e.msg}`)
        .join(' | ');
    } else if (typeof data.detail === 'string') {
      detail = data.detail;
    } else {
      detail = JSON.stringify(data);
    }
  } catch (_) {}
  return detail;
}

export async function getNpdHealth() {
  const res = await fetch(`${BASE_URL}/health`);
  if (!res.ok) {
    throw new Error(await parseError(res));
  }
  return res.json();
}

export async function extractNpdSpecs(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch(`${BASE_URL}/extract-specs`, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    throw new Error(await parseError(res));
  }

  return res.json();
}

export async function generateNpdDxf(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch(`${BASE_URL}/generate-dxf`, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    throw new Error(await parseError(res));
  }

  const disposition = res.headers.get('content-disposition') || '';
  const filenameMatch = disposition.match(/filename="?([^\";]+)"?/i);
  const filename = filenameMatch ? filenameMatch[1] : 'generated.dxf';

  return {
    blob: await res.blob(),
    filename,
  };
}

export { BASE_URL as NPD_BASE_URL };
